(() => {
  const initFreshGallery = (root) => {
    if (!root || root.dataset.freshGalleryInitialized === 'true') return;
    root.dataset.freshGalleryInitialized = 'true';

    const mainImage = root.querySelector('[data-fresh-gallery-main]');
    const mainVideo = root.querySelector('[data-fresh-gallery-video]');
    const thumbs = Array.from(root.querySelectorAll('[data-fresh-gallery-thumb]'));
    const previous = root.querySelector('[data-fresh-gallery-prev]');
    const next = root.querySelector('[data-fresh-gallery-next]');
    if (!mainImage || !mainVideo || !thumbs.length) return;

    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const show = (index) => {
      activeIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeIndex];
      const source = thumb.dataset.src;
      if (!source) return;
      const isVideo = thumb.dataset.mediaType === 'video';
      root.classList.toggle('is-fresh-video', isVideo);
      root.classList.toggle('is-fresh-infographic', !isVideo && thumb.dataset.infographic === 'true');
      root.classList.toggle('is-fresh-overlay-detail', !isVideo && thumb.dataset.overlayDetail === 'true');
      root.classList.toggle('is-fresh-primary-video', isVideo && thumb.dataset.primaryVideo === 'true');

      thumbs.forEach((item, itemIndex) => {
        const active = itemIndex === activeIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });

      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

      if (isVideo) {
        mainImage.classList.remove('is-changing');
        mainVideo.setAttribute('aria-label', thumb.dataset.alt || 'Ürün kullanım videosu');
        if (mainVideo.getAttribute('src') !== source) {
          mainVideo.src = source;
          mainVideo.load();
        }
        const playPromise = mainVideo.play();
        if (playPromise) playPromise.catch(() => {});
        return;
      }

      mainVideo.pause();
      mainImage.classList.add('is-changing');
      window.setTimeout(() => {
        mainImage.src = source;
        mainImage.alt = thumb.dataset.alt || '';
        mainImage.onload = () => mainImage.classList.remove('is-changing');
        window.setTimeout(() => mainImage.classList.remove('is-changing'), 650);
      }, 150);
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    previous?.addEventListener('click', () => show(activeIndex - 1));
    next?.addEventListener('click', () => show(activeIndex + 1));
  };

  const boot = () => document.querySelectorAll('[data-fresh-conversion-v4]').forEach(initFreshGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
